import PropTypes from 'prop-types';
import config from '../../../config';

export const isDevelopment = () => {
  if (!config) {
    console.warn('config not found in DevelopmentOnly component');
    return false;
  }
  const env = (config.environment || '').toLowerCase();
  return env === 'development' || env === 'local';
};

const DevelopmentOnly = ({ children = null }) => {
  if (!children) return null;
  return isDevelopment() ? children : null;
};

DevelopmentOnly.propTypes = {
  children: PropTypes.node,
};
export default DevelopmentOnly;
